module.exports = __webpack_public_path__ + "img/irsicon.e08a028e.jpg";